/*
 * Decléor — Footer newsletter → Klaviyo (with skin-concern collection)
 * ---------------------------------------------------------------------------
 * The footer newsletter form (snippets/newsletter-concern.liquid) submits straight
 * to Klaviyo's client-side "Create Client Subscription" API — exactly like the
 * on-site popup — so it subscribes the email to the configured list AND records the
 * visitor's main skin concern in the SAME `primary_skin_concern` profile property
 * the popup uses. Shopify's {% form 'customer' %} can't store custom fields, which
 * is why we talk to Klaviyo directly here.
 *
 * Config is read from data-* attributes on the <form data-klaviyo-newsletter>:
 *   data-company  Klaviyo public API key / site id (safe to expose client-side)
 *   data-list     target list id (e.g. "SU - Newsletter Decléor")
 *   data-source   stored in Klaviyo as the subscription's custom_method_detail
 *   data-success / data-error / data-error-email  user-facing messages
 *
 * No dependencies; no-ops if the form is absent. Public key only — never a private key.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  /* The `subscriptions` object of the payload's profile only exists from revision 2025-01-15
     (Klaviyo changelog). With 2024-10-15 every sign-up was refused: HTTP 400 "'subscriptions' is
     not a valid field for the resource 'profile'" (measured 2026-11-03, footer and calendar popup). */
  var REVISION = '2026-07-15';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function setMessage(form, state, text) {
    var el = form.querySelector('[data-kl-message]');
    if (!el) { return; }
    el.textContent = text || '';
    if (state) { el.setAttribute('data-state', state); } else { el.removeAttribute('data-state'); }
  }

  function bind(form) {
    if (form.dataset.klBound) { return; }
    form.dataset.klBound = '1';

    var company = form.getAttribute('data-company');
    var listId = form.getAttribute('data-list');
    var source = form.getAttribute('data-source') || 'Footer newsletter';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!company || !listId) { return; }

      // Honeypot: bots fill hidden fields. Pretend success, send nothing.
      var hp = form.querySelector('[data-kl-hp]');
      if (hp && hp.value) {
        setMessage(form, 'success', form.getAttribute('data-success') || '');
        return;
      }

      var emailEl = form.querySelector('input[type="email"]');
      var email = emailEl ? emailEl.value.trim() : '';
      if (!EMAIL_RE.test(email)) {
        setMessage(form, 'error', form.getAttribute('data-error-email') || 'Adresse e-mail invalide.');
        if (emailEl) { emailEl.focus(); }
        return;
      }

      var checked = form.querySelector('input[name="primary_skin_concern"]:checked');
      var concern = checked ? checked.value : '';

      var profileAttributes = {
        email: email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      };
      if (concern) {
        profileAttributes.properties = { primary_skin_concern: concern };
      }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: profileAttributes } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; }
      form.setAttribute('data-loading', '');
      setMessage(form, null, '');

      var ok = false;
      window.fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.status >= 200 && res.status < 300) {
            ok = true;
            form.setAttribute('data-submitted', '');
            setMessage(form, 'success', form.getAttribute('data-success') || 'Merci, c’est confirmé !');
            if (emailEl) { emailEl.value = ''; }
            if (checked) { checked.checked = false; }
            return;
          }
          return res.text().then(function (txt) {
            if (window.console) { console.warn('[Klaviyo newsletter] HTTP ' + res.status, txt); }
            setMessage(form, 'error', form.getAttribute('data-error') || 'Une erreur est survenue. Réessayez.');
          });
        })
        .catch(function (err) {
          if (window.console) { console.warn('[Klaviyo newsletter] network error', err); }
          setMessage(form, 'error', form.getAttribute('data-error') || 'Une erreur est survenue. Réessayez.');
        })
        .then(function () {
          form.removeAttribute('data-loading');
          // After a confirmed signup, keep the button disabled so the success can't be re-submitted.
          if (!ok && btn) { btn.disabled = false; }
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-klaviyo-newsletter]');
    for (var i = 0; i < forms.length; i++) { bind(forms[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
